import { gql } from '@apollo/client';

export const GET_VENDORS_BY_REPRESENTATIVE_ID = gql`
  query GetVendorsByRepresentativeId($representativeId: ID!) {
    getVendorsByRepresentativeId(representativeId: $representativeId) {
      createdAt
      email
      firstName
      lastName
      paperWorkFinished
      phone
      vendorId
      vendorName
      vendorRepresentatives {
        email
        firstName
        id
        lastName
        roles
      }
      projects {
        connected
        createdAt
        createdBy
        firstName
        id
        lastName
        mqttEndpoint
        name
        status
        type
        updatedAt
        vendorProjectOwnerEmail
        vendorProjectOwnerId
        certificate {
          certificateArn
          certificateId
          expirationTime {
            notAfter
            notBefore
          }
        }
      }
      contactInfo {
        city
        country
        state
        street
        zip
      }
    }
  }
`;
